<template>
  <div class="medical-record-detail">
    <el-row>
      <el-col :span="24">
        <div class="medical-record-detail__section">
          <el-card class="box-card medical-case-card" shadow="hover">
            <div slot="header" class="clearfix card-header">
              <i class="el-icon-card-header"></i>
              <span>病例信息</span>
            </div>
            <!-- 病例信息字段统一通过配置渲染 -->
            <div class="medical-case-info-body">
              <el-row v-for="(row, rowIndex) in baseInfoRows" :key="rowIndex" :gutter="16">
                <el-col v-for="cell in row" :key="cell.key" :span="cell.span" :class="cell.className">
                  {{ cell.text }}
              </el-col>
            </el-row>
        </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="medical-record-detail__section">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix card-header">
              <i class="el-icon-card-header"></i>
              <span>处方</span>
            </div>
            <el-row :gutter="20">
              <el-col v-if="!hasPrescriptions && tongueImages.length === 0" :span="24">
                <el-empty description="暂无处方信息"></el-empty>
              </el-col>
              <div v-if="tztl.length > 0">
                <div class="pres-section-title">体质调理 {{ tztl.length }}种
                </div>
                <el-card-content class="pres-list-item" v-for="(item, index) in tztl" :key="'tz-' + index">
                  <template #cardconTent>
                    <div class="pres-detail-box">
                      <div class="pres-detail-head">
                      <div class="drag-title">九合引</div>
                        <div v-if="item.presMedicalNo" class="pres-sub">病历编号：{{ item.presMedicalNo }}</div>
                          </div>
                      <div class="pres-detail-drugs">
                        <template v-if="item.medicateCounts && item.medicateCounts.length">
                          <div
                            v-for="(m, mi) in item.medicateCounts"
                            :key="'tz-m-' + index + '-' + mi"
                            class="pres-detail-drug-line"
                          >
                            {{ m.drug_name }}{{ m.drug_spec != null && m.drug_spec !== '' ? m.drug_spec : '' }}
                          </div>
                        </template>
                        <div v-else class="pres-detail-drug-line">{{ item.drug_name }}{{ item.drug_spec }}</div>
                        </div>
                      <div class="pres-detail-grid">
                        <div class="pres-grid-row pres-grid-row-3">
                          <div class="pres-grid-cell">
                            <span class="pres-grid-label">单次用量：</span>
                            <span class="pres-grid-val">{{ item.mt_single_number }}{{ item.mt_unit }}</span>
                          </div>
                          <div class="pres-grid-cell pres-grid-cell--center">
                            <span class="pres-grid-label">用药频次：</span>
                            <span class="pres-grid-val">{{ item.mt_frequency }}</span>
                          </div>
                          <div class="pres-grid-cell pres-grid-cell--end">
                            <span class="pres-grid-label">用药天数：</span>
                            <span class="pres-grid-val">{{ item.mt_days }}</span>
                          </div>
                        </div>
                        <div class="pres-grid-row pres-grid-row-2">
                          <div class="pres-grid-cell">
                            <span class="pres-grid-label">用法/给药途径：</span>
                            <span class="pres-grid-val">{{ item.mt_usage }}</span>
                          </div>
                          <div class="pres-grid-cell pres-grid-cell--end">
                            <span class="pres-grid-label">开方总量：</span>
                            <span class="pres-grid-val">{{ item.mt_number }}{{ item.packing_unit }}</span>
                          </div>
                        </div>
                      </div>
                      <div v-if="item.remark != null && item.remark !== ''" class="pres-detail-extra">
                        <span class="pres-grid-label">嘱托/备注：</span>
                        <span class="pres-grid-val">{{ item.remark }}</span>
                      </div>
                    </div>
                  </template>
                </el-card-content>
              </div>
              <div v-if="tfcf.length > 0">
                <div class="pres-section-title">贴敷处方 {{ tfcf.length }}种
                </div>
                <el-card-content class="pres-list-item" v-for="(item, index) in tfcf" :key="index">
                  <template #cardconTent>
                    <div class="pres-detail-box">
                      <div class="pres-detail-head">
                        <div class="drag-title">贴敷处方{{ index + 1 }}</div>
                        <div v-if="item.presMedicalNo" class="pres-sub">病历编号：{{ item.presMedicalNo }}</div>
                      </div>
                      <div class="pres-detail-drugs pres-detail-drugs--three-cols">
                        <div
                          v-for="(medicate, i) in chineseDrugLinesForDisplay(item)"
                          :key="i"
                          class="pres-detail-drug-line"
                        >
                          <span class="pres-detail-drug-name">{{ medicate.drug_name }}</span>
                          <span class="pres-detail-drug-unit">{{ formatChineseDoseDisplayLine(medicate) }}</span>
                        </div>
                      </div>
                      <div v-if="item.onceDisplay" class="pres-detail-grid">
                        <!-- <div class="pres-grid-row pres-grid-row-3">
                          <div class="pres-grid-cell">
                            <span class="pres-grid-label">单次用量：</span>
                            <span class="pres-grid-val">{{ item.onceDisplay.singleDoseText }}</span>
                          </div>
                          <div class="pres-grid-cell pres-grid-cell--center">
                            <span class="pres-grid-label">用药频次：</span>
                            <span class="pres-grid-val">{{ item.onceDisplay.mt_frequency }}</span>
                          </div>
                          <div class="pres-grid-cell pres-grid-cell--end">
                            <span class="pres-grid-label">用药天数：</span>
                            <span class="pres-grid-val">{{ item.onceDisplay.mt_days }}</span>
                          </div>
                         </div> -->
                        <div class="pres-grid-row pres-grid-row-3">
                          <div class="pres-grid-cell">
                            <span class="pres-grid-label">穴位：</span>
                            <span class="pres-grid-val">{{ item.onceDisplay.acupoint }}</span>
                          </div>
                          <div class="pres-grid-cell">
                            <span class="pres-grid-label">频次：</span>
                            <span class="pres-grid-val">{{ item.onceDisplay.mt_frequency }}</span>
                          </div>
                          <div class="pres-grid-cell pres-grid-cell--end">
                            <span class="pres-grid-label">总量：</span>
                            <span class="pres-grid-val">{{ item.onceDisplay.totalQtyText }}</span>
                          </div>
                        </div>
                      </div>
                      <!-- <div v-if="item.onceDisplay && item.onceDisplay.acupoint" class="pres-detail-extra">
                        <span class="pres-grid-label">穴位：</span>
                        <span class="pres-grid-val">{{ item.onceDisplay.acupoint }}</span>
                      </div> -->
                    </div>
                  </template>
                </el-card-content>
              </div>
              <div v-if="zycf.length > 0">
                <div class="pres-section-title">中药处方 {{ zycf.length }}种
                </div>
                <el-card-content class="pres-list-item" v-for="(item, index) in zycf" :key="index">
                  <template #cardconTent>
                    <div class="pres-detail-box">
                      <div class="pres-detail-head">
                      <div class="drag-title">中药处方{{ index + 1 }}</div>
                        <div v-if="item.presMedicalNo" class="pres-sub">病历编号：{{ item.presMedicalNo }}</div>
                      </div>
                      <div class="pres-detail-drugs">
                        <div
                          v-for="(medicate, i) in chineseDrugLinesForDisplay(item)"
                            :key="i"
                          class="pres-detail-drug-line"
                        >
                          {{ medicate.drug_name }}{{ medicate.drug_spec != null && medicate.drug_spec !== '' ? medicate.drug_spec : '' }}
                          </div>
                        </div>
                      <div v-if="item.onceDisplay" class="pres-detail-grid">
                        <div class="pres-grid-row pres-grid-row-3">
                          <div class="pres-grid-cell">
                            <span class="pres-grid-label">单次用量：</span>
                            <span class="pres-grid-val">{{ item.onceDisplay.singleDoseText }}</span>
                      </div>
                          <div class="pres-grid-cell pres-grid-cell--center">
                            <span class="pres-grid-label">用药频次：</span>
                            <span class="pres-grid-val">{{ item.onceDisplay.mt_frequency }}</span>
                        </div>
                          <div class="pres-grid-cell pres-grid-cell--end">
                            <span class="pres-grid-label">用药天数：</span>
                            <span class="pres-grid-val">{{ item.onceDisplay.mt_days }}</span>
                        </div>
                        </div>
                        <div class="pres-grid-row pres-grid-row-2">
                          <div class="pres-grid-cell">
                            <span class="pres-grid-label">用法/给药途径：</span>
                            <span class="pres-grid-val">{{ item.onceDisplay.mt_usage }}</span>
                      </div>
                          <div class="pres-grid-cell pres-grid-cell--end">
                            <span class="pres-grid-label">开方总量：</span>
                            <span class="pres-grid-val">{{ item.onceDisplay.totalQtyText }}</span>
                        </div>
                        </div>
                        </div>
                      <div v-if="item.onceDisplay && item.onceDisplay.acupoint" class="pres-detail-extra">
                        <span class="pres-grid-label">穴位：</span>
                        <span class="pres-grid-val">{{ item.onceDisplay.acupoint }}</span>
                      </div>
                      <div v-if="item.onceDisplay && item.onceDisplay.remark" class="pres-detail-extra">
                        <span class="pres-grid-label">嘱托/备注：</span>
                        <span class="pres-grid-val">{{ item.onceDisplay.remark }}</span>
                      </div>
                    </div>
                  </template>
                </el-card-content>
              </div>
              <div v-if="xycf.length > 0">
                <div class="pres-section-title">西药处方 {{ xycf.length }}种
                </div>
                <el-card-content class="pres-list-item" v-for="(item, index) in xycf" :key="'xy-' + index">
                  <template #cardconTent>
                    <div class="pres-detail-box">
                      <div class="pres-detail-head">
                      <div class="drag-title">西药处方{{ index + 1 }}</div>
                        <div v-if="item.presMedicalNo" class="pres-sub">病历编号：{{ item.presMedicalNo }}</div>
                      </div>
                      <div class="pres-detail-drugs">
                        <template v-if="item.medicateCounts && item.medicateCounts.length">
                          <div
                            v-for="(m, mi) in item.medicateCounts"
                            :key="'xy-m-' + index + '-' + mi"
                            class="pres-detail-drug-line"
                          >
                            {{ m.drug_name }}{{ m.drug_spec != null && m.drug_spec !== '' ? m.drug_spec : '' }}
                        </div>
                        </template>
                        <div v-else class="pres-detail-drug-line">{{ item.drug_name }}{{ item.drug_spec }}</div>
                        </div>
                      <div class="pres-detail-grid">
                        <div class="pres-grid-row pres-grid-row-3">
                          <div class="pres-grid-cell">
                            <span class="pres-grid-label">单次用量：</span>
                            <span class="pres-grid-val">{{ item.mt_single_number }}{{ item.mt_unit }}</span>
                        </div>
                          <div class="pres-grid-cell pres-grid-cell--center">
                            <span class="pres-grid-label">用药频次：</span>
                            <span class="pres-grid-val">{{ item.mt_frequency }}</span>
                      </div>
                          <div class="pres-grid-cell pres-grid-cell--end">
                            <span class="pres-grid-label">用药天数：</span>
                            <span class="pres-grid-val">{{ item.mt_days }}</span>
                        </div>
                        </div>
                        <div class="pres-grid-row pres-grid-row-2">
                          <div class="pres-grid-cell">
                            <span class="pres-grid-label">用法/给药途径：</span>
                            <span class="pres-grid-val">{{ item.mt_usage }}</span>
                        </div>
                          <div class="pres-grid-cell pres-grid-cell--end">
                            <span class="pres-grid-label">开方总量：</span>
                            <span class="pres-grid-val">{{ item.mt_number }}{{ item.packing_unit }}</span>
                          </div>
                        </div>
                      </div>
                      <div v-if="item.remark != null && item.remark !== ''" class="pres-detail-extra">
                        <span class="pres-grid-label">嘱托/备注：</span>
                        <span class="pres-grid-val">{{ item.remark }}</span>
                      </div>
                    </div>
                  </template>
                </el-card-content>
              </div>
              <div v-if="zjcf.length > 0">
                <div class="pres-section-title">注射处方 {{ zjcf.length }}种
                </div>
                <el-card-content class="pres-list-item" v-for="(item, index) in zjcf" :key="'zj-' + index">
                  <template #cardconTent>
                    <div class="pres-detail-box">
                      <div class="pres-detail-head">
                        <div class="drag-title">注射处方{{ index + 1 }}</div>
                        <div v-if="item.presMedicalNo" class="pres-sub">病历编号：{{ item.presMedicalNo }}</div>
                      </div>
                      <div class="pres-detail-drugs">
                        <template v-if="item.medicateCounts && item.medicateCounts.length">
                          <div
                            v-for="(m, mi) in item.medicateCounts"
                            :key="'zj-m-' + index + '-' + mi"
                            class="pres-detail-drug-line"
                          >
                            {{ m.drug_name }}{{ m.drug_spec != null && m.drug_spec !== '' ? m.drug_spec : '' }}
                          </div>
                        </template>
                        <div v-else class="pres-detail-drug-line">{{ item.drug_name }}{{ item.drug_spec }}</div>
                      </div>
                      <div class="pres-detail-grid">
                        <div class="pres-grid-row pres-grid-row-3">
                          <div class="pres-grid-cell">
                            <span class="pres-grid-label">单次用量：</span>
                            <span class="pres-grid-val">{{ item.mt_single_number }}{{ item.mt_unit }}</span>
                          </div>
                          <div class="pres-grid-cell pres-grid-cell--center">
                            <span class="pres-grid-label">用药频次：</span>
                            <span class="pres-grid-val">{{ item.mt_frequency }}</span>
                          </div>
                          <div class="pres-grid-cell pres-grid-cell--end">
                            <span class="pres-grid-label">用药天数：</span>
                            <span class="pres-grid-val">{{ item.mt_days }}</span>
                          </div>
                        </div>
                        <div class="pres-grid-row pres-grid-row-2">
                          <div class="pres-grid-cell">
                            <span class="pres-grid-label">用法/给药途径：</span>
                            <span class="pres-grid-val">{{ item.mt_usage }}</span>
                          </div>
                          <div class="pres-grid-cell pres-grid-cell--end">
                            <span class="pres-grid-label">开方总量：</span>
                            <span class="pres-grid-val">{{ item.mt_number }}{{ item.packing_unit }}</span>
                          </div>
                        </div>
                      </div>
                      <div v-if="item.remark != null && item.remark !== ''" class="pres-detail-extra">
                        <span class="pres-grid-label">嘱托/备注：</span>
                        <span class="pres-grid-val">{{ item.remark }}</span>
                      </div>
                    </div>
                  </template>
                </el-card-content>
              </div>
              <!-- 舌象：与上方各处方相同的列表结构（el-card-content + pres-detail-box） -->
              <div v-if="tongueImages.length > 0">
                <div class="pres-section-title">舌象 {{ tongueImages.length }}张</div>
                <el-card-content
                  class="pres-list-item"
                  v-for="(img, idx) in tongueImages"
                  :key="'tongue-' + idx"
                >
                  <template #cardconTent>
                    <div class="pres-detail-box">
                      <div class="pres-detail-head">
                        <div class="drag-title">舌象 {{ idx + 1 }}</div>
                        <div v-if="img.create_time" class="pres-sub">拍摄时间：{{ formatTongueTime(img.create_time) }}</div>
                      </div>
                      <div class="pres-detail-drugs">
                        <el-image
                          :src="tongueImgSrc(img)"
                          fit="cover"
                          class="pres-tongue-el-image"
                          :preview-src-list="tonguePreviewList"
                          referrerpolicy="no-referrer"
                        >
                          <div slot="error" class="pres-tongue-image-err">图片加载失败（可检查地址或防盗链）</div>
                        </el-image>
                      </div>
                      <div
                        v-if="formatTongueRecognize(img.recognize_result)"
                        class="pres-detail-extra pres-tongue-recognize"
                      >
                        <span class="pres-grid-label">识别结果：</span>
                        <span class="pres-grid-val pres-tongue-recognize-text">{{ formatTongueRecognize(img.recognize_result) }}</span>
                      </div>
                    </div>
                  </template>
                </el-card-content>
              </div>
            </el-row>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import elCardContent from "@/components/elCardContent";

// API 基地址；病历详情接口数据结构见团队文档：
// pres_result：各数组均为处方头列表；medicateGroups 每项一张处方，无分组则用根上 medicateCounts；
// 西药/九和饮/注射共用拆卡 + mergeWestDetailForDisplay；
// 中药：拆卡 + 仅挂明细；贴敷：平铺明细时按品名「消肿止痛贴」切段为多张贴敷处方（含该物料行）。
// tongueImages：详情根、bingli_recult、pres_result 下各处方及 medicateGroups；img_url / recognize_result / create_time
const API_HOST = process.env.VUE_APP_API_HOST;

/**
 * 解析 find_patient_record_detail 的 axios 响应，得到详情根对象（兼容 res.data.data.data 等嵌套）
 * @param {object} res axios 完整响应
 * @returns {object|null}
 */
function unwrapRecordDetailPayload(res) {
  const body = res && res.data;
  if (body == null || typeof body !== 'object') {
    return null;
  }
  let cur = body;
  for (let i = 0; i < 4; i++) {
    if (cur == null || typeof cur !== 'object') {
      return null;
    }
    if (cur.pres_result || cur.bingli_recult) {
      return cur;
    }
    if (cur.data != null && typeof cur.data === 'object') {
      cur = cur.data;
      continue;
    }
    return cur;
  }
  return cur && typeof cur === 'object' ? cur : null;
}

/**
 * 兼容明细字段大小写：后端可能返回 medicateCounts 或 MedicateCounts
 * @param {object|null|undefined} row
 * @returns {Array}
 */
function getMedicateCounts(row) {
  if (row == null || typeof row !== 'object') {
    return [];
  }
  if (Array.isArray(row.medicateCounts)) {
    return row.medicateCounts;
  }
  if (Array.isArray(row.MedicateCounts)) {
    return row.MedicateCounts;
  }
  return [];
}

/** @param {object} row */
function isTongueLikeRow(row) {
  if (row == null || typeof row !== 'object') {
    return false;
  }
  const url = row.img_url || row.imgUrl || row.image_url || row.url;
  return typeof url === 'string' && url.trim().length > 5;
}

/**
 * 统一单条舌象字段（展示与预览均用 img_url）
 * @param {object} raw 接口原始项
 * @returns {{ img_url: string, recognize_result?: *, create_time?: * }|null}
 */
function mapTongueRow(raw) {
  if (!isTongueLikeRow(raw)) {
    return null;
  }
  const img_url = (raw.img_url || raw.imgUrl || raw.image_url || raw.url || '').trim();
  return {
    img_url,
    recognize_result: raw.recognize_result != null ? raw.recognize_result : raw.recognizeResult,
    create_time: raw.create_time != null ? raw.create_time : raw.createTime
  };
}

/**
 * @param {Array} list 原始列表
 * @returns {Array<{ img_url, recognize_result, create_time }>}
 */
function dedupeTongueList(list) {
  if (!Array.isArray(list)) {
    return [];
  }
  const seen = new Set();
  const out = [];
  for (const raw of list) {
    const m = mapTongueRow(raw);
    if (!m) {
      continue;
    }
    if (seen.has(m.img_url)) {
      continue;
    }
    seen.add(m.img_url);
    out.push(m);
  }
  return out;
}

/**
 * 在未知字段名下，深度查找「数组且元素均含图片地址」的舌象列表
 * @param {object} root 详情根对象
 * @returns {Array}
 */
function heuristicScanTongueArrays(root) {
  const queue = [root];
  const seen = new Set();
  while (queue.length) {
    const cur = queue.shift();
    if (cur == null || typeof cur !== 'object') {
      continue;
    }
    if (seen.has(cur)) {
      continue;
    }
    seen.add(cur);
    if (Array.isArray(cur)) {
      if (cur.length > 0 && cur.every((x) => isTongueLikeRow(x))) {
        return cur;
      }
      cur.forEach((x) => queue.push(x));
      continue;
    }
    for (const key of Object.keys(cur)) {
      const v = cur[key];
      if (Array.isArray(v) && v.length > 0) {
        const allImg = v.every((x) => isTongueLikeRow(x));
        if (!allImg) {
          /* skip */
        } else {
          const nameHit = /舌|she|tongue|xiang|medical|opd|file|image/i.test(String(key));
          const metaHit = v.some(
            (x) =>
              x != null &&
              ('recognize_result' in x || 'create_time' in x || 'recognizeResult' in x || 'createTime' in x)
          );
          if (nameHit || metaHit) {
            return v;
          }
        }
      }
      if (v && typeof v === 'object') {
        queue.push(v);
      }
    }
  }
  return [];
}

/**
 * 从已解包的详情根对象中提取舌象（具名字段优先，否则启发式扫描）
 * @param {object|null} data 详情 data
 * @returns {Array<{ img_url, recognize_result, create_time }>}
 */
function extractTongueImagesFromDetailPayload(data) {
  if (data == null || typeof data !== 'object') {
    return [];
  }
  const primary = normalizeTongueImagesFromDetailData(data);
  if (primary.length > 0) {
    return dedupeTongueList(primary);
  }
  const guessed = heuristicScanTongueArrays(data);
  return dedupeTongueList(guessed);
}

/**
 * 从病历详情接口 data 中解析舌象列表（兼容多种后端字段命名；可嵌套 bingli_recult）
 * @param {object|null|undefined} data find_patient_record_detail 返回的 data 或病历子对象
 * @param {number} depth 递归深度上限，避免异常环状结构
 * @returns {Array<{ img_url?: string, recognize_result?: string|null, create_time?: string }>}
 */
function normalizeTongueImagesFromDetailData(data, depth = 0) {
  if (data == null || typeof data !== 'object' || depth > 3) {
    return [];
  }
  const asArray = (v) => (Array.isArray(v) ? v : null);
  const direct =
    asArray(data.tongueImages) ||
    asArray(data.tongue_images) ||
    asArray(data.TongueImages) ||
    asArray(data.shexiang_list) ||
    asArray(data.shexiangList) ||
    asArray(data.shexiang);
  if (direct && direct.length > 0) {
    return direct;
  }
  const files = data.opd_medical_file;
  if (Array.isArray(files)) {
    const byType = files.filter((row) => {
      if (row == null || typeof row !== 'object') {
        return false;
      }
      const t = row.type ?? row.file_type ?? row.medical_file_type;
      return t === 1 || t === '1';
    });
    if (byType.length > 0) {
      return byType;
    }
    /** 后端未标记 type=1 时，按「含图片 URL」过滤（避免整段舌象被丢弃） */
    const byShape = files.filter((row) => isTongueLikeRow(row));
    if (byShape.length > 0) {
      return byShape;
    }
  }
  const bl = data.bingli_recult;
  if (bl && typeof bl === 'object') {
    return normalizeTongueImagesFromDetailData(bl, depth + 1);
  }
  return [];
}

/**
 * 舌象挂在 pres_result 内：各处方桶、处方头、或 medicateGroups 分组上（字段同具名/ opd_medical_file）
 * @param {object|null|undefined} presResult data.pres_result
 * @returns {Array<object>} 原始舌象项（未去重）
 */
function extractTongueRawFromPresResult(presResult) {
  if (presResult == null || typeof presResult !== 'object') {
    return [];
  }
  const collected = [];
  collected.push(...normalizeTongueImagesFromDetailData(presResult));
  const bucketKeys = ['jiuhePres', 'tiefuPres', 'chinesePres', 'westernPres', 'injectionPres'];
  for (let bi = 0; bi < bucketKeys.length; bi++) {
    const bucket = presResult[bucketKeys[bi]];
    const list = Array.isArray(bucket)
      ? bucket
      : bucket != null && typeof bucket === 'object'
        ? [bucket]
        : [];
    for (let pi = 0; pi < list.length; pi++) {
      const pres = list[pi];
      if (pres == null || typeof pres !== 'object') {
        continue;
      }
      collected.push(...normalizeTongueImagesFromDetailData(pres));
      const linesFlat = getMedicateCounts(pres);
      if (Array.isArray(linesFlat)) {
        for (let li = 0; li < linesFlat.length; li++) {
          const line = linesFlat[li];
          if (line != null && typeof line === 'object') {
            collected.push(...normalizeTongueImagesFromDetailData(line));
          }
        }
      }
      const groups = pres.medicateGroups;
      if (!Array.isArray(groups)) {
        continue;
      }
      for (let gi = 0; gi < groups.length; gi++) {
        const g = groups[gi];
        if (g != null && typeof g === 'object') {
          collected.push(...normalizeTongueImagesFromDetailData(g));
          const gLines = getMedicateCounts(g);
          if (Array.isArray(gLines)) {
            for (let gli = 0; gli < gLines.length; gli++) {
              const gLine = gLines[gli];
              if (gLine != null && typeof gLine === 'object') {
                collected.push(...normalizeTongueImagesFromDetailData(gLine));
              }
            }
          }
        }
      }
    }
  }
  return collected;
}

/**
 * 详情根对象 + 处方树中的舌象合并去重（含 extractTongueImagesFromDetailPayload 的启发式）
 * @param {object|null} data unwrap 后的病历详情根
 * @returns {Array<{ img_url, recognize_result, create_time }>}
 */
function mergeAllTongueImagesForRecord(data) {
  if (data == null || typeof data !== 'object') {
    return [];
  }
  const fromRoot = extractTongueImagesFromDetailPayload(data);
  const fromPres = extractTongueRawFromPresResult(data.pres_result);
  return dedupeTongueList([...fromRoot, ...fromPres]);
}

/**
 * 舌象图片地址规范化（OSS 路径中若含空格，浏览器请求可能失败，需转为 %20）
 * @param {string|null|undefined} url 原始 img_url
 * @returns {string}
 */
function normalizeTongueImageUrl(url) {
  if (url == null || url === '') {
    return '';
  }
  return String(url).trim().replace(/ /g, '%20');
}

/**
 * recognize_result：接口多为 JSON 字符串，必须用 JSON.parse；已是对象则直接使用
 * @param {string|object|null|undefined} raw 原始 recognize_result
 * @returns {object|null} 解析失败返回 null
 */
function parseRecognizeResultJson(raw) {
  if (raw == null || raw === '') {
    return null;
  }
  if (typeof raw === 'object') {
    return raw;
  }
  if (typeof raw !== 'string') {
    return null;
  }
  const s = raw.trim();
  if (!s) {
    return null;
  }
  try {
    return JSON.parse(s);
  } catch (e) {
    return null;
  }
}

/**
 * 将解析后的舌象识别对象格式化为可读文案（常见结构：顶层或 data 下 symptom1~3、*_prob、*_info）
 * @param {object|null} o parseRecognizeResultJson 的返回值
 * @returns {string} 无可展示内容时返回空串
 */
function formatTongueRecognizeObject(o) {
  if (o == null || typeof o !== 'object') {
    return '';
  }
  const d = o.data != null && typeof o.data === 'object' ? o.data : o;
  const lines = [];
  for (let i = 1; i <= 3; i++) {
    const nameKey = `symptom${i}`;
    const probKey = `${nameKey}_prob`;
    const infoKey = `${nameKey}_info`;
    const adjKey = `${nameKey}_info_adjust`;
    if (d[nameKey] == null || d[nameKey] === '') {
      continue;
    }
    const parts = [`体质倾向：${d[nameKey]}`];
    if (d[probKey] != null && d[probKey] !== '') {
      parts.push(`概率 ${d[probKey]}`);
    }
    if (d[infoKey] != null && String(d[infoKey]).trim() !== '') {
      const info = String(d[infoKey]);
      parts.push(info.length > 200 ? `${info.slice(0, 200)}…` : info);
    } else if (d[adjKey] != null && String(d[adjKey]).trim() !== '') {
      const adj = String(d[adjKey]);
      parts.push(adj.length > 200 ? `${adj.slice(0, 200)}…` : adj);
    }
    lines.push(parts.join('｜'));
  }
  if (lines.length > 0) {
    return lines.join('\n');
  }
  return Object.keys(o)
    .filter((k) => {
      const v = o[k];
      return v != null && typeof v !== 'object' && typeof v !== 'function';
    })
    .map((k) => `${k}：${o[k]}`)
    .join('；');
}
/** 贴敷底材：药名列表不展示，数据中仍保留（拆方、开方总量仍用该行） */
const CHINESE_PATCH_HIDE_DRUG_NAME = '消肿止痛贴'

/**
 * 中药/贴敷明细单行展示：数量 + 单位（cmc_number / cmc_unit，必要时拼接 packing_unit）
 * @param {object|null} line opd_pres_chinese_detail 行
 * @returns {string}
 */
function formatChineseDoseDisplayLine(line) {
  if (!line || typeof line !== 'object') {
    return ''
  }
  const num = line.cmc_number
  const u = line.cmc_unit != null ? String(line.cmc_unit).trim() : ''
  const packRaw = line.packing_unit != null ? String(line.packing_unit).trim() : ''
  const base = [num, u].filter((x) => x !== undefined && x !== null && x !== '').join('')
  if (!packRaw) {
    return base || ''
  }
  if (packRaw === u) {
    return base || packRaw || ''
  }
  if (base) {
    return `${base}${packRaw}`
  }
  return packRaw || ''
}
// 基本信息字段布局配置（label/value 展示结构）
const BASE_INFO_LAYOUT = [
  [
    {key: 'mrId', label: '病历 ID', labelSpan: 4, valueSpan: 8},
    {key: 'diagnosis', label: '诊断', labelSpan: 4, valueSpan: 8}
  ],
  [
    {key: 'chiefComplaint', label: '主诉', labelSpan: 4, valueSpan: 8},
    {key: 'doctor', label: '开方医生', labelSpan: 4, valueSpan: 8}
  ],
  [
    {key: 'clinic', label: '诊所', labelSpan: 4, valueSpan: 8},
    {key: 'visitTime', label: '就诊时间', labelSpan: 4, valueSpan: 8}
  ],
  [
    {key: 'patientId', label: '患者会员 ID', labelSpan: 4, valueSpan: 8},
    {key: 'patientName', label: '患者姓名', labelSpan: 4, valueSpan: 8}
  ],
  [
    {key: 'patientGender', label: '性别', labelSpan: 4, valueSpan: 8},
    {key: 'birthday', label: '出生日期', labelSpan: 4, valueSpan: 8}
  ],
  [
    {key: 'address', label: '患者地址', labelSpan: 4, valueSpan: 8},
    {key: 'phone', label: '手机号', labelSpan: 4, valueSpan: 8}
  ],
];

export default {
  name: "MedicalRecordDetail",
  components: {
    elCardContent,
  },
  props: {
    mr_id: {
      type: String
    },
    dataItem:{
      type: Array,
      default: () => []
    },
    rowData:{
      type: Object,
      default: () => {}
    },
    clinic_profile_data:{
      type: Object,
      default: () => {}
    }
  },
  computed: {
    // 是否存在详情接口返回的病例信息
    hasDetailRecord() {
      return !!(this.patient_record_detail_data && this.patient_record_detail_data.bingli_recult);
    },
    // 统一后的病例信息字段值
    recordValues() {
      if (this.hasDetailRecord) {
        const record = this.patient_record_detail_data.bingli_recult;
        return {
          mrId: record.mr_id,
          diagnosis: record.mr_diagnosis,
          chiefComplaint: record.mr_zs,
          doctor: record.doctor_name,
          clinic: record.clinic_name,
          visitTime: record.mr_visit_time,
          patientId: record.patient_id,
          patientName: record.patient_name,
          patientGender: record.patient_gender,
          birthday: record.patient_birthday,
          address: record.patient_address,
          phone: record.patient_phone
        };
      }

      const fallback = this.dataItem && this.dataItem[0] ? this.dataItem[0] : {};
      const clinicProfile = this.clinic_profile_data || {};
      const birthday = fallback.birthday ? fallback.birthday.split('T')[0] : '';

      return {
        mrId: this.mr_id || fallback.mr_id || '',
        diagnosis: fallback.mr_diagnosis,
        chiefComplaint: fallback.symptoms,
        doctor: this.rowData ? this.rowData.doctor_name : '',
        clinic: clinicProfile["诊所名称"],
        visitTime: this.rowData ? this.rowData["月份"] : '',
        patientId: fallback.patient_id,
        patientName: fallback.pat_name,
        patientGender: fallback.pat_sex,
        birthday,
        address: clinicProfile["详细位置"],
        phone: fallback.phone
      };
    },
    // 基本信息按布局分组
    baseInfoRows() {
      return BASE_INFO_LAYOUT.map((row) =>
        row.flatMap((field) => {
          const value = this.recordValues[field.key] || '';
          return [
            {
              key: `${field.key}-label`,
              span: field.labelSpan,
              text: `${field.label}：`,
              className: 'el-col-tbl-key'
            },
            {
              key: `${field.key}-value`,
              span: field.valueSpan,
              text: value,
              className: 'el-col-tbl-val'
            }
          ];
        })
      );
    },
    // 是否存在任何处方信息（各列表均保证为数组，避免 undefined.length）
    hasPrescriptions() {
      const lists = [this.tztl, this.tfcf, this.zycf, this.xycf, this.zjcf];
      return lists.some((arr) => Array.isArray(arr) && arr.length > 0);
    },
    /** 舌象大图预览列表（与 tongueImgSrc 同样处理空格，避免预览打不开） */
    tonguePreviewList() {
      return (this.tongueImages || [])
        .map((i) => normalizeTongueImageUrl(i && i.img_url))
        .filter(Boolean);
    }
  },
  watch: {
    /**
     * 病历 id 变化时重新拉详情（部分父组件未使用 :key 时仍要能刷新舌象等）
     * @param {string} next 新的 mr_id
     */
    mr_id(next) {
      if (next) {
        this.get_detail_mr();
      } else {
        this.clearPrescriptionLists();
      }
    }
  },
  methods: {
    formatChineseDoseDisplayLine,
    /**
     * 单张舌象图用于 el-image :src 的地址（规范空格）
     * @param {{ img_url?: string }} img 舌象项
     * @returns {string}
     */
    tongueImgSrc(img) {
      return normalizeTongueImageUrl(img && img.img_url);
    },
    /**
     * 格式化舌象拍摄时间（接口 ISO 8601）
     * @param {string} iso 原始时间字符串
     * @returns {string} 展示用文本
     */
    formatTongueTime(iso) {
      if (!iso) {
        return '';
      }
      return String(iso).replace('T', ' ').slice(0, 19);
    },
    /**
     * 展示用：recognize_result 为 JSON 字符串时先 JSON.parse，再格式化为可读文案
     * @param {string|object|null|undefined} raw 接口返回的 recognize_result
     * @returns {string} 无内容或解析失败返回空串
     */
    formatTongueRecognize(raw) {
      const o = parseRecognizeResultJson(raw);
      return formatTongueRecognizeObject(o);
    },
    /**
     * 中药/贴敷卡片药名区：过滤底材「消肿止痛贴」（数据中仍保留，用于拆方与总量）
     * @param {object} item 卡片，含 medicateCounts
     * @returns {object[]} 用于 v-for 的明细行
     */
    chineseDrugLinesForDisplay(item) {
      const lines = (item && item.medicateCounts) || []
      return lines.filter((row) => String(row.drug_name || '').trim() !== CHINESE_PATCH_HIDE_DRUG_NAME)
    },
    // 处方数据归类处理
    dataHandle(data) {
      if (data == null || typeof data !== 'object') {
        return { tztl: [], tfcf: [], zycf: [], xycf: [], zjcf: [] };
      }
      const tztl = []
      const tfcf = []
      const zycf = []
      const xycf = []
      const zjcf = [] // 注射处方

      // 处方归类：仅使用文档约定字段名 westernPres / jiuhePres / injectionPres / chinesePres / tiefuPres
      const physiquePres = Array.isArray(data.jiuhePres) ? data.jiuhePres : []
      const stickingPres = Array.isArray(data.tiefuPres) ? data.tiefuPres : []
      const chinesePres = Array.isArray(data.chinesePres) ? data.chinesePres : []
      const westernPres = Array.isArray(data.westernPres) ? data.westernPres : []
      const rawZj = data.injectionPres
      const zjPres = Array.isArray(rawZj) ? rawZj : rawZj && typeof rawZj === 'object' ? [rawZj] : []

      /** 贴敷切段物料名；开方总量展示优先取最后一行该品名（与 split 逻辑一致） */
      const TIEFU_PATCH_PRODUCT_NAME = CHINESE_PATCH_HIDE_DRUG_NAME

      /**
       * `medicateGroups` 每项对应一张处方：有 `medicateCounts` 则作为该张处方的明细列表；
       * 否则将该对象视为一条明细（单张单味药等场景）。
       * @param {object} pres 处方头（含 medicateGroups）
       * @returns {Array<{ medicateCounts: object[] }>}
       */
      const normalizeGroups = (pres) => {
        const groups = pres.medicateGroups || []
        if (!Array.isArray(groups) || groups.length === 0) {
          return []
        }
        return groups.map((group) => {
          const groupLines = getMedicateCounts(group)
          if (group != null && typeof group === 'object' && groupLines.length > 0) {
            return { medicateCounts: groupLines }
          }
          return { medicateCounts: group != null && typeof group === 'object' ? [group] : [] }
        })
      }

      /**
       * 所有处方类型统一拆卡：先按 medicateGroups 每项一张；无分组则用根上 medicateCounts 一张；
       * 仍无明细行但处方头含西药字段时，出一张由 mergeWestDetailForDisplay 从头上合并的卡片。
       * @param {object} pres 处方头
       * @returns {Array<{ medicateCounts: object[] }>} 每张卡片仅含明细数组
       */
      const eachPrescriptionCards = (pres) => {
        if (!pres || typeof pres !== 'object') {
          return []
        }
        const fromGroups = normalizeGroups(pres)
        if (fromGroups.length > 0) {
          return fromGroups
        }
        const lines = getMedicateCounts(pres)
        if (Array.isArray(lines) && lines.length > 0) {
          return [{ medicateCounts: lines }]
        }
        const headWest =
          pres.drug_name ||
          pres.mt_number ||
          pres.mt_usage ||
          pres.mt_single_number
        if (headWest) {
          return [{ medicateCounts: [] }]
        }
        return []
      }

      /**
       * 仅从对象链中读取文档列出的西药明细字段（opd_pres_west_detail）
       * @param {object[]} objs 按优先级顺序查找
       * @param {string[]} keys 文档字段名
       */
      const pickFirst = (objs, keys) => {
        for (const obj of objs) {
          if (!obj || typeof obj !== 'object') continue
          for (const k of keys) {
            if (!Object.prototype.hasOwnProperty.call(obj, k)) continue
            const v = obj[k]
            if (v !== undefined && v !== null && v !== '') {
              return v
            }
          }
        }
        return ''
      }

      const WEST_DETAIL_KEYS = ['drug_name', 'drug_spec', 'mt_single_number', 'mt_unit', 'mt_days', 'mt_frequency', 'mt_usage', 'mt_number', 'packing_unit', 'remark']

      /**
       * 西药/九和饮/注射展示：合并处方头 medical_no 与首条明细的文档字段
       * @param {object} pres 处方头
       * @param {object} item 分组 { medicateCounts }
       */
      const mergeWestDetailForDisplay = (pres, item) => {
        if (!item || typeof item !== 'object') {
          return item
        }
        const lines = item.medicateCounts || []
        const first = lines[0] || {}
        const chain = [item, pres, first]
        const out = {
          medicateCounts: lines,
          presMedicalNo: pres.medical_no || ''
        }
        WEST_DETAIL_KEYS.forEach((k) => {
          out[k] = pickFirst(chain, [k])
        })
        return out
      }

      /**
       * 取最后一行指定药品名的明细（贴敷取最后一贴「消肿止痛贴」作总量依据）
       * @param {object[]} lines medicateCounts
       * @param {string} drugName 品名
       * @returns {object|null}
       */
      const findLastLineByDrugName = (lines, drugName) => {
        if (!Array.isArray(lines) || !drugName) {
          return null
        }
        let last = null
        lines.forEach((line) => {
          if (line && String(line.drug_name || '').trim() === drugName) {
            last = line
          }
        })
        return last
      }

      /**
       * 从多条明细中按字段名顺序取第一个有效值
       * @param {object[]} lines 明细行列表
       * @param {string[]} keys 字段名优先级
       * @returns {string|number|*}
       */
      const pickFirstLineValue = (lines, keys) => {
        if (!Array.isArray(lines)) {
          return ''
        }
        for (const line of lines) {
          if (!line || typeof line !== 'object') continue
          for (const k of keys) {
            const v = line[k]
            if (v !== undefined && v !== null && v !== '') {
              return v
            }
          }
        }
        return ''
      }

      /**
       * 组装中药/贴敷卡片：onceDisplay 含与西药卡片同构的网格字段 + 穴位/备注
       * @param {string} presMedicalNo 病历编号 medical_no
       * @param {object[]} lines medicateCounts
       * @returns {{ presMedicalNo: string, medicateCounts: object[], onceDisplay: object }}
       */
      const buildChinesePrescriptionCard = (presMedicalNo, lines) => {
        const firstLine = lines[0] || null
        const patchLine = findLastLineByDrugName(lines, TIEFU_PATCH_PRODUCT_NAME)
        const totalLine = patchLine || (lines.length ? lines[lines.length - 1] : null)
        return {
          presMedicalNo: presMedicalNo || '',
          medicateCounts: lines,
          onceDisplay: {
            mt_days: pickFirstLineValue(lines, ['mt_days', 'MtDays']),
            mt_frequency: pickFirstLineValue(lines, ['mt_frequency', 'MtFrequency']),
            mt_usage: pickFirstLineValue(lines, ['mt_usage', 'MtUsage']),
            remark: pickFirstLineValue(lines, ['remark', 'Remark']),
            acupoint: pickFirstLineValue(lines, ['acupoint', 'Acupoint', 'xuewei', 'tie_acupoint', 'acupoints', 'point']),
            singleDoseText: formatChineseDoseDisplayLine(firstLine),
            totalQtyText: formatChineseDoseDisplayLine(totalLine)
          }
        }
      }

      /**
       * 中药类（chinesePres）：拆卡后仅挂 medical_no 与明细行
       * @param {object} pres 处方头
       * @param {Array} target 目标列表（zycf）
       */
      const pushChinesePrescriptions = (pres, target) => {
        eachPrescriptionCards(pres).forEach((card) => {
          const lines = card.medicateCounts || []
          if (lines.length === 0) {
            return
          }
          target.push(buildChinesePrescriptionCard(pres.medical_no || '', lines))
        })
      }

      /**
       * 将平铺的贴敷明细按「消肿止痛贴」切分为多张卡片数据
       * @param {object[]} flatRows medicateGroups 平铺后的 opd_pres_chinese_detail 行
       * @returns {Array<{ medicateCounts: object[] }>}
       */
      const splitTiefuByPatchProduct = (flatRows) => {
        if (!Array.isArray(flatRows) || flatRows.length === 0) {
          return []
        }
        const cards = []
        let buf = []
        flatRows.forEach((row) => {
          if (!row || typeof row !== 'object') {
            return
          }
          buf.push(row)
          if (String(row.drug_name || '').trim() === TIEFU_PATCH_PRODUCT_NAME) {
            cards.push({ medicateCounts: buf.slice() })
            buf = []
          }
        })
        if (buf.length > 0) {
          cards.push({ medicateCounts: buf })
        }
        return cards
      }

      /**
       * 判断是否贴敷嵌套结构：首项带 medicateCounts 数组则按 normalizeGroups 逐组展示，不切「消肿止痛贴」
       * @param {object} pres 处方头
       * @returns {object[]|null} 平铺明细行；null 表示走嵌套分组
       */
      const getTiefuFlatDetailRowsOrNull = (pres) => {
        const groups = pres.medicateGroups || []
        if (!Array.isArray(groups) || groups.length === 0) {
          return []
        }
        const first = groups[0]
        if (first != null && typeof first === 'object' && getMedicateCounts(first).length > 0) {
          return null
        }
        return groups.filter((g) => g && typeof g === 'object')
      }

      /**
       * 贴敷（tiefuPres）：平铺 medicateGroups 时按「消肿止痛贴」拆多张处方；否则与中药相同拆卡
       * @param {object} pres 处方头
       * @param {Array} target tfcf
       */
      const pushTiefuPrescriptions = (pres, target) => {
        const flatOrNested = getTiefuFlatDetailRowsOrNull(pres)
        let cards = []
        if (flatOrNested === null) {
          cards = normalizeGroups(pres)
        } else if (flatOrNested.length > 0) {
          cards = splitTiefuByPatchProduct(flatOrNested)
        }
        if (cards.length === 0) {
          // 兼容后端将贴敷明细直接挂在处方根（medicateCounts / MedicateCounts）的场景，仍按「消肿止痛贴」切段
          const rootLines = getMedicateCounts(pres)
          if (Array.isArray(rootLines) && rootLines.length > 0) {
            cards = splitTiefuByPatchProduct(rootLines)
          }
        }
        if (cards.length === 0) {
          eachPrescriptionCards(pres).forEach((card) => {
            const lines = card.medicateCounts || []
            if (lines.length > 0) {
              cards.push({ medicateCounts: lines })
            }
          })
        }
        cards.forEach((card) => {
          const lines = card.medicateCounts || []
          if (lines.length === 0) {
            return
          }
          target.push(buildChinesePrescriptionCard(pres.medical_no || '', lines))
        })
      }

      /**
       * 西药明细类（jiuhePres / westernPres / injectionPres）：拆卡后与处方头合并展示字段
       * @param {object} pres 处方头
       * @param {Array} target 目标列表（tztl / xycf / zjcf）
       */
      const pushWestPrescriptions = (pres, target) => {
        eachPrescriptionCards(pres).forEach((card) => {
          target.push(mergeWestDetailForDisplay(pres, card))
        })
      }

      /**
       * 西药处方（westernPres）：每个药品明细单独展示为一张卡片
       * @param {object} pres 处方头
       * @param {Array} target 目标列表（xycf）
       */
      const pushWesternPerDrug = (pres, target) => {
        eachPrescriptionCards(pres).forEach((card) => {
          const lines = (card && card.medicateCounts) || []
          if (!Array.isArray(lines) || lines.length === 0) {
            target.push(mergeWestDetailForDisplay(pres, card))
            return
          }
          lines.forEach((line) => {
            const singleCard = { medicateCounts: [line] }
            target.push(mergeWestDetailForDisplay(pres, singleCard))
          })
        })
      }

      /** 所有类型处方：按 pres_result 分类后，拆卡与合并规则与上相同 */
      physiquePres.forEach((pres) => pushWestPrescriptions(pres, tztl))
      stickingPres.forEach((pres) => pushTiefuPrescriptions(pres, tfcf))
      chinesePres.forEach((pres) => pushChinesePrescriptions(pres, zycf))
      westernPres.forEach((pres) => pushWesternPerDrug(pres, xycf))
      zjPres.forEach((pres) => pushWestPrescriptions(pres, zjcf))
      return {tztl, tfcf, zycf, xycf, zjcf}
    },
    /**
     * 清空各类型处方列表（请求失败或数据异常时使用）
     */
    clearPrescriptionLists() {
      this.tztl = [];
      this.tfcf = [];
      this.zycf = [];
      this.xycf = [];
      this.zjcf = [];
      this.tongueImages = [];
    },
    // 请求病例详情并拆分处方结构
    get_detail_mr() {
      const id = this.mr_id != null && this.mr_id !== '' ? String(this.mr_id).trim() : '';
      if (!id) {
        return;
      }
      this.$http.get(API_HOST + "/find_patient_record_detail?mr_id=" + id).then((res) => {
          console.log("res", res);
          const data = unwrapRecordDetailPayload(res);
          if (data == null || typeof data !== 'object') {
            this.clearPrescriptionLists();
            return;
          }
          this.patient_record_detail_data = data;
          const pres = data.pres_result;
          const { tztl, tfcf, zycf, xycf, zjcf } = this.dataHandle(pres);
          this.tztl = tztl;
          this.tfcf = tfcf;
          this.zycf = zycf;
          this.xycf = xycf;
          this.zjcf = zjcf;
          this.tongueImages = mergeAllTongueImagesForRecord(data);
      }).catch(() => {
          this.clearPrescriptionLists();
          this.$message.error('加载病例详情失败，请稍后重试');
        });
    },
  },
  mounted() {
    // 初始化获取病例详情
    this.get_detail_mr()
  },
  data() {
    return {
      // 体质调理处方
      tztl: [],
      // 贴敷处方
      tfcf: [],
      // 中药处方
      zycf: [],
      // 西药处方
      xycf: [],
      // 注射处方
      zjcf: [],
      // 病例详情结构
      patient_record_detail_data: {
        bingli_recult: {
          mr_id: "",
          mr_zs: "",
          mr_diagnosis: "",
          doctor_name: "",
          clinic_name: "",
          mr_visit_time: "",
          patient_name:"",
          patient_gender:"",
          patient_birthday:"",
          patient_id:"",
          patient_address:"",
          patient_phone:"",
        }
      },
      /** 舌象 opd_medical_file type=1 */
      tongueImages: [],
    }
  }
}
</script>

<style scoped>
/**
 * 病历详情整体布局：纵向分段间距，与各段 el-card 统一为大屏深色描边。
 */
.medical-record-detail {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.medical-record-detail__section {
  margin: 0;
}

.medical-record-detail__section :deep(.el-card.box-card) {
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: #3c3f4a;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
  overflow: hidden;
}

.medical-record-detail__section :deep(.el-card__header) {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding: 14px 20px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.18) 0%, rgba(0, 0, 0, 0.1) 100%);
}

.medical-record-detail__section :deep(.el-card__body) {
  padding: 16px 20px 18px;
}

.medical-record-detail__section :deep(.card-header) {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
}

.medical-record-detail :deep(.el-empty__description) {
  color: rgba(255, 255, 255, 0.55);
}

.medical-record-detail :deep(.el-empty__image) {
  opacity: 0.88;
}

/** 病例信息区：略收紧全局 40px 行高，但不压得过分紧凑 */
.medical-record-detail :deep(.medical-case-card .el-card__header) {
  padding: 12px 18px;
}

.medical-record-detail :deep(.medical-case-card .el-card__body) {
  padding: 14px 18px 16px;
}

.medical-record-detail :deep(.medical-case-info-body .el-row) {
  margin-bottom: 0 !important;
}

.medical-record-detail :deep(.medical-case-info-body .el-col-tbl-key) {
  height: auto !important;
  min-height: 0;
  line-height: 1.45 !important;
  font-size: 12px !important;
  padding: 5px 0 !important;
}

.medical-record-detail :deep(.medical-case-info-body .el-col-tbl-val) {
  height: auto !important;
  min-height: 0;
  line-height: 1.45 !important;
  font-size: 14px !important;
  padding: 5px 0 !important;
}

/** 处方分组小标题（替代原偏大、偏灰的 zlxm-row-text2） */
.pres-section-title {
  margin: 14px 0 6px;
  padding: 8px 12px 8px 14px;
  border-left: 3px solid #68f5b9;
  border-radius: 0 8px 8px 0;
  background: rgba(104, 245, 185, 0.06);
  font-size: 15px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.88);
  line-height: 1.4;
}

.pres-section-title:first-child {
  margin-top: 0;
}

/** 单张处方外层 quick-list 与上下文的间距（类挂载在 el-card-content 根节点） */
.medical-record-detail :deep(.pres-list-item.quick-list) {
  margin-top: 8px;
  margin-bottom: 6px;
}

.card-header {
  border: none;
}

.medicate-wrapper {
  display: flex;
  flex-wrap: wrap;
}

.medicate-text {
  margin: 5px 5px 0 0;
  font-size: 15px;
  font-weight: bold;
  color: white;
}

.drag-title {
  font-weight: bold;
  color: white;
}

.medicate-label {
  color: white;
}

.medicate-desc {
  color: white;
}

.medicate-row {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
}

.pres-sub {
  font-size: 13px;
  color: #999;
  margin-bottom: 8px;
}

.medicate-detail-block {
  margin-top: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.medicate-detail-block:last-child {
  border-bottom: none;
}

/** 处方块：层次清晰、药名列表左对齐避免两侧空荡，底栏标签弱化、数值突出 */
.pres-detail-box {
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: linear-gradient(
    165deg,
    rgba(52, 54, 62, 0.95) 0%,
    rgba(36, 38, 46, 0.98) 48%,
    rgba(30, 32, 40, 0.99) 100%
  );
  box-shadow:
    0 6px 20px rgba(0, 0, 0, 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.06);
  padding: 14px 16px 12px;
  margin-bottom: 14px;
  box-sizing: border-box;
}

.pres-detail-box .pres-detail-head {
  margin-bottom: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.pres-detail-box .pres-detail-head .drag-title {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.03em;
  color: #f2f3f5;
  line-height: 1.3;
  margin: 0 0 6px 0;
}

.pres-detail-box .pres-detail-head .pres-sub {
  font-size: 12px;
  color: #8b9099;
  margin-bottom: 0;
  line-height: 1.4;
}

.pres-detail-drugs {
  text-align: left;
  margin: 10px 0 8px;
  padding: 8px 12px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.pres-detail-drug-line {
  font-size: 14px;
  font-weight: 500;
  color: #e8eaef;
  line-height: 1.5;
  margin: 0;
  padding: 7px 0;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.08);
  padding-left: 10px;
  position: relative;
}

.pres-detail-drug-line::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(109, 244, 186, 0.65);
}

.pres-detail-drug-line:last-child {
  border-bottom: none;
  padding-bottom: 5px;
}

.pres-detail-drug-line:first-child {
  padding-top: 5px;
}

/* 贴敷处方药味：一行最多三列，超出自动换行 */
.pres-detail-drugs--three-cols {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 12px;
  row-gap: 0;
}

.pres-detail-drugs--three-cols .pres-detail-drug-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 12px;
  padding-right: 10px;
}

.pres-detail-drugs--three-cols .pres-detail-drug-name {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pres-detail-drugs--three-cols .pres-detail-drug-unit {
  flex-shrink: 0;
  margin-left: 8px;
  color: #ffffff;
}

.pres-detail-drugs--three-cols .pres-detail-drug-line:last-child {
  border-bottom: 1px dashed rgba(255, 255, 255, 0.08);
  padding-bottom: 7px;
}

.pres-detail-grid {
  margin-top: 0;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.pres-grid-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-top: 6px;
  font-size: 12px;
  line-height: 1.55;
  color: rgba(230, 232, 238, 0.95);
}

.pres-grid-row:first-of-type {
  margin-top: 0;
}

.pres-grid-row-3 .pres-grid-cell {
  flex: 1;
  min-width: 28%;
}

.pres-grid-cell--center {
  text-align: center;
}

.pres-grid-cell--end {
  text-align: right;
}

.pres-grid-row-2 .pres-grid-cell {
  flex: 1;
  min-width: 42%;
}

.pres-grid-row-2 .pres-grid-cell--end {
  text-align: right;
}

.pres-grid-label {
  color: #9aa0ac;
  font-weight: 400;
}

.pres-grid-val {
  color: #f5f6f8;
  font-weight: 600;
}

.pres-detail-extra {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 12px;
  line-height: 1.5;
  color: rgba(200, 204, 214, 0.92);
}

.pres-detail-extra .pres-grid-label {
  color: #9aa0ac;
}

.pres-detail-extra .pres-grid-val {
  color: #e2e5eb;
  font-weight: 500;
}

/** 舌象列表项内缩略图（外层与其它处方共用 pres-detail-drugs） */
.pres-tongue-el-image {
  width: 128px;
  max-width: 100%;
  height: 96px;
  border-radius: 6px;
  overflow: hidden;
  display: block;
}

.pres-tongue-el-image :deep(.el-image__inner) {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pres-tongue-image-err {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 128px;
  max-width: 100%;
  min-height: 72px;
  max-height: 96px;
  padding: 4px 6px;
  font-size: 11px;
  line-height: 1.3;
  color: rgba(255, 255, 255, 0.55);
  background: rgba(0, 0, 0, 0.25);
  border-radius: 6px;
}

.pres-tongue-recognize .pres-tongue-recognize-text {
  display: block;
  margin-top: 4px;
  white-space: pre-line;
  color: #8fcb9d;
  font-weight: 400;
  line-height: 1.45;
  max-height: 10.5em;
  overflow: hidden;
}
</style>
